module.exports = __webpack_public_path__ + "img/BurgerButton.73fb09a5.svg";